import { forwardRef } from 'react'
import './controls.css'
const Tabs = forwardRef(function Tabs({ className = '', ...props }, ref) {
    return <div role="tablist" {...props} ref={ref} className={'uiTabs ' + className} />
})
Tabs.Tab = forwardRef(function Tab({ active, className = '', ...props }, ref) {
    const selected = active ?? props['aria-selected'] ?? props['aria-pressed'] ?? false
    return <button role="tab" {...props} aria-selected={selected} data-active={selected} ref={ref} className={'uiTab ' + className} />
})
export default Tabs
